import moment from 'moment';
import _ from 'lodash';
import i18n from 'i18next';

export const createDurationTime = (time = 0) => {
  if (time < 1000) {
    return i18n.t('少于 1 秒');
  }
  const timeMoment = moment.duration(time);
  let day = '';
  let hour = '';
  let minute = '';
  let second = '';

  if (timeMoment.days()) {
    day = `${timeMoment.days()}${i18n.t('天')}`;
  }
  if (timeMoment.hours()) {
    hour = `${timeMoment.hours()}${i18n.t('小时')}`;
  }
  if (timeMoment.minutes()) {
    minute = `${timeMoment.minutes()}${i18n.t('分')}`;
  }
  if (timeMoment.seconds()) {
    second = `${timeMoment.seconds()}${i18n.t('秒')}`;
  }
  return day + hour + minute + second;
};
export const getMaxMinDate = (month = 12) => {
  const start = moment();
  const end = moment().subtract(month, 'month');
  return {
    max: `${start.format('YYYY-MM-DD')} 24:00:00`,
    min: `${end.format('YYYY-MM-DD')} 00:00:00`
  };
};

export const getConvTagChildren = data => {
  const convTagMap = {};

  function getChildren(data, level, parentId, color) {
    let newData = [];
    const children = data.filter(d => d.level === level && (parentId ? d.parent_id === parentId : true));
    if (children.length > 0) {
      newData = children.map(c => {
        const i = {
          ...c,
          name: c.tag_name,
          key: c.id,
          value: c.id,
          active: false,
          label: c.tag_name,
          title: c.tag_name,
          data: {
            ...c
          }
        };
        const subChildren = getChildren(data, level + 1, c.id, color || c.color);

        if (color) {
          i.color = color;
          i.data.color = color;
        }
        convTagMap[c.id] = { ...i };
        if (subChildren.length > 0) {
          i.children = subChildren;
        }
        i.cls = `${i.color} tag`;
        return i;
      });
    }
    return newData;
  }

  const treeList = getChildren(data, 1);
  return { convTagMap, treeList };
};

export default {};
